import { es } from './es';
import { en } from './en';
import { zh } from './zh';
import { useLocaleStore } from '../store/locale.store';

export type { Translations } from './es';

export const LOCALE_OPTIONS = [
  { value: 'es', label: 'Español', flagIso: 'mx' },
  { value: 'en', label: 'English', flagIso: 'us' },
  { value: 'zh', label: '中文',    flagIso: 'cn' },
] as const;

const DICT = { es, en, zh } as const;

/** Hook principal — devuelve el objeto de traducciones para el idioma activo */
export function useT() {
  const locale = useLocaleStore((s) => s.locale);
  return DICT[locale] ?? es;
}
